import React, { useState, useEffect, useCallback } from "react";
import { speakText } from "../utils/speech";
import SpellingPractice from "./SpellingPractice";
import FlashCardView from "./FlashCardView";
import WordListView from "./WordListView";
import ChineseWritingView from "./ChineseWritingView";
import ChineseSpellingView from "./ChineseSpellingView";
import ChineseFlashCardView from "./ChineseFlashCardView";
import GamesHub from "./GamesHub";
import BottomNav from "./BottomNav";
import Header from "./Header";
import Sidebar from "./Sidebar";
import "../styles/SpellingTrainer.css";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AssignmentIcon from "@mui/icons-material/Assignment";
import EditIcon from "@mui/icons-material/Edit";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import CreateIcon from "@mui/icons-material/Create";
import CheckIcon from "@mui/icons-material/Check";
import TranslateIcon from "@mui/icons-material/Translate";
import AbcIcon from "@mui/icons-material/Abc";
import BrushIcon from "@mui/icons-material/Brush";

const ENGLISH_LISTS = [
  { value: "K2_Week6.txt", label: "K2 Spelling Week 6" },
  { value: "K2_Week7.txt", label: "K2 Spelling Week 7" },
  { value: "K2_Week8.txt", label: "K2 Spelling Week 8" },
  { value: "K2_Week9.txt", label: "K2 Spelling Week 9" },
  { value: "K2_24Mar.txt", label: "K2 Spelling 24 Mar" },
  { value: "K2_01Apr.txt", label: "K2 Spelling 01 Apr" },
  { value: "K2_07Apr.txt", label: "K2 Spelling 07 Apr" },
  { value: "K2_14Apr.txt", label: "K2 Spelling 14 Apr" },
  { value: "K2_21Apr.txt", label: "K2 Spelling 21 Apr" },
  { value: "K2_28Apr.txt", label: "K2 Spelling 28 Apr" },
  { value: "K2_05May.txt", label: "K2 Spelling 05 May" },
  { value: "K2_12May.txt", label: "K2 Spelling 12 May" },
  { value: "K2_19May.txt", label: "K2 Spelling 19 May" },
  { value: "K2_26May.txt", label: "K2 Spelling 26 May" },
  { value: "K2_07Jul.txt", label: "K2 Spelling 07 Jul" },
  { value: "K2_14Jul.txt", label: "K2 Spelling 14 Jul" },
  { value: "K2_20Jul.txt", label: "K2 Spelling 20 Jul" },
  { value: "K2_28Jul.txt", label: "K2 Spelling 28 Jul" },
  { value: "K2_04Aug.txt", label: "K2 Spelling 04 Aug" },
  { value: "K2_11Aug.txt", label: "K2 Spelling 11 Aug" },
  { value: "K2_18Aug.txt", label: "K2 Spelling 18 Aug" },
  { value: "K2_25Aug.txt", label: "K2 Spelling 25 Aug" },
  { value: "K2_01Sep.txt", label: "K2 Spelling 01 Sep" },
  { value: "PSLE_Spelling_A.txt", label: "PSLE Spelling A" },
  { value: "PSLE_Spelling_B.txt", label: "PSLE Spelling B" },
  { value: "PSLE_Spelling_C.txt", label: "PSLE Spelling C" },
  { value: "PSLE_Spelling_D.txt", label: "PSLE Spelling D" },
  { value: "PSLE_Spelling_E.txt", label: "PSLE Spelling E" },
  { value: "PSLE_Spelling_F.txt", label: "PSLE Spelling F" },
  { value: "PSLE_Spelling_G.txt", label: "PSLE Spelling G" },
  { value: "PSLE_Spelling_H.txt", label: "PSLE Spelling H" },
  { value: "PSLE_Spelling_I.txt", label: "PSLE Spelling I" },
  { value: "PSLE_Spelling_J.txt", label: "PSLE Spelling J" },
  { value: "PSLE_Spelling_K.txt", label: "PSLE Spelling K" },
  { value: "PSLE_Spelling_L.txt", label: "PSLE Spelling L" },
  { value: "PSLE_Spelling_M.txt", label: "PSLE Spelling M" },
  { value: "PSLE_Spelling_N.txt", label: "PSLE Spelling N" },
  { value: "PSLE_Spelling_O.txt", label: "PSLE Spelling O" },
  { value: "PSLE_Spelling_P.txt", label: "PSLE Spelling P" },
  { value: "PSLE_Spelling_Q.txt", label: "PSLE Spelling Q" },
  { value: "PSLE_Spelling_R.txt", label: "PSLE Spelling R" },
  { value: "PSLE_Spelling_S.txt", label: "PSLE Spelling S" },
  { value: "PSLE_Spelling_T.txt", label: "PSLE Spelling T" },
  { value: "PSLE_Spelling_U.txt", label: "PSLE Spelling U" },
  { value: "PSLE_Spelling_V.txt", label: "PSLE Spelling V" },
  { value: "PSLE_Spelling_W.txt", label: "PSLE Spelling W" },
  { value: "PSLE_Spelling_Y.txt", label: "PSLE Spelling Y" },
];

const CHINESE_LISTS = [
  { value: "Chinese_HSK1_Basic.txt", label: "HSK1 Basic Characters" },
  { value: "Chinese_HSK1_Family.txt", label: "HSK1 Family & People" },
  { value: "K2_Chinese_0402.txt", label: "K2 Chinese 0402" },
  { value: "K2_Chinese_0409.txt", label: "K2 Chinese 0409" },
  { value: "K2_Chinese_0416.txt", label: "K2 Chinese 0416" },
  { value: "K2_Chinese_0423.txt", label: "K2 Chinese 0423" },
  { value: "K2_Chinese_0430.txt", label: "K2 Chinese 0430" },
  { value: "K2_Chinese_0507.txt", label: "K2 Chinese 0507" },
  { value: "K2_Chinese_0514.txt", label: "K2 Chinese 0514" },
  { value: "K2_Chinese_0521.txt", label: "K2 Chinese 0521" },
  { value: "K2_Chinese_09Jul.txt", label: "K2 Chinese 09 Jul" },
  { value: "K2_Chinese_16Jul.txt", label: "K2 Chinese 16 Jul" },
  { value: "K2_Chinese_23Jul.txt", label: "K2 Chinese 23 Jul" },
  { value: "K2_Chinese_30Jul.txt", label: "K2 Chinese 30 Jul" },
  { value: "K2_Chinese_6Aug.txt", label: "K2 Chinese 6 Aug" },
  { value: "K2_Chinese_13Aug.txt", label: "K2 Chinese 13 Aug" },
  { value: "K2_Chinese_20Aug.txt", label: "K2 Chinese 20 Aug" },
  { value: "K2_Chinese_27Aug.txt", label: "K2 Chinese 27 Aug" },
  { value: "K2_Chinese_Week7.txt", label: "K2 Chinese Week 7" },
  { value: "K2_Chinese_Week8.txt", label: "K2 Chinese Week 8" },
  { value: "K2_Chinese_Week9.txt", label: "K2 Chinese Week 9" },
];

export default function SpellingTrainer() {
  const [words, setWords] = useState([]);
  const [chineseWords, setChineseWords] = useState([]);
  const [kidName, setKidName] = useState("");
  const [fileUploaded, setFileUploaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedList, setSelectedList] = useState("");
  const [showTextBoxInput, setShowTextBoxInput] = useState(false);
  const [textBoxContent, setTextBoxContent] = useState("");
  const [showChineseTextBoxInput, setShowChineseTextBoxInput] = useState(false);
  const [chineseTextBoxContent, setChineseTextBoxContent] = useState("");
  const [practiceType, setPracticeType] = useState("");
  const [activeView, setActiveView] = useState("");
  const [flashIndex, setFlashIndex] = useState(0);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleEnglishListChange = async (fileName) => {
    setLoading(true);
    try {
      const response = await fetch(`/data/${fileName}`);
      const text = await response.text();
      const lines = text.split(/\r?\n/).filter(line => line.trim() !== "");
      setWords(lines.map(line => {
        const [wordRaw, meaningEnRaw, meaningZhRaw] = line.split("|").map(s => s.trim());
        return { word: wordRaw, meaningEn: meaningEnRaw, meaningZh: meaningZhRaw };
      }));
      setFileUploaded(true);
      setSelectedList(fileName);
      setActiveView("");
    } catch (e) {
      console.error("Error loading list:", e);
    }
    setLoading(false);
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = async (event) => {
      const text = event.target.result;
      const lines = text.split(/\r?\n/).filter(line => line.trim() !== "");
      setLoading(true);
      const parsedWords = await Promise.all(lines.map(async (line) => {
        const parts = line.split("|").map(s => s.trim());
        let wordRaw = parts[0];
        let meaningEn = parts[1] || "";
        let meaningZh = parts[2] || "";
        if (parts.length === 1 || !meaningEn || !meaningZh) {
          const fetched = await fetchMeaning(wordRaw);
          meaningEn = meaningEn || fetched.meaningEn;
          meaningZh = meaningZh || fetched.meaningZh;
        }
        return { word: wordRaw, meaningEn, meaningZh };
      }));
      setWords(parsedWords);
      setFileUploaded(true);
      setActiveView("");
      setLoading(false);
    };
    reader.readAsText(file);
  };

  const handleTextBoxSubmit = async () => {
    if (!textBoxContent.trim()) return;
    setLoading(true);
    const lines = textBoxContent.split(/\r?\n/).filter(line => line.trim() !== "");
    const parsedWords = await Promise.all(lines.map(async (line) => {
      const parts = line.split("|").map(s => s.trim());
      let wordRaw = parts[0];
      let meaningEn = parts[1] || "";
      let meaningZh = parts[2] || "";
      if (parts.length === 1 || !meaningEn || !meaningZh) {
        const fetched = await fetchMeaning(wordRaw);
        meaningEn = meaningEn || fetched.meaningEn;
        meaningZh = meaningZh || fetched.meaningZh;
      }
      return { word: wordRaw, meaningEn, meaningZh };
    }));
    setWords(parsedWords);
    setFileUploaded(true);
    setSelectedList("Custom Text Input");
    setShowTextBoxInput(false);
    setActiveView("");
    setLoading(false);
  };

  const loadChineseList = async (fileName) => {
    setLoading(true);
    try {
      const response = await fetch(`/data/${fileName}`);
      if (!response.ok) throw new Error(`File not found: ${fileName}`);
      const text = await response.text();
      const lines = text.split(/\r?\n/).filter(line => line.trim() !== "");
      const parsed = lines.map(line => {
        const [chinese, pinyin, english] = line.split("|").map(s => s.trim());
        return { chinese, pinyin, english };
      });
      setChineseWords(parsed);
      setSelectedList(fileName);
      setFileUploaded(true);
      setActiveView("");
    } catch (error) {
      console.error("Error loading Chinese list:", error);
    }
    setLoading(false);
  };

  const handleChineseFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (event) => {
      const text = event.target.result;
      const lines = text.split(/\r?\n/).filter(line => line.trim() !== "");
      const parsed = lines.map(line => {
        const [chinese, pinyin, english] = line.split("|").map(s => s.trim());
        return { chinese: chinese || "", pinyin: pinyin || "", english: english || "" };
      });
      setChineseWords(parsed);
      setFileUploaded(true);
      setSelectedList("Custom File");
      setActiveView("");
    };
    reader.readAsText(file);
  };

  const handleChineseTextBoxSubmit = () => {
    if (!chineseTextBoxContent.trim()) return;
    const lines = chineseTextBoxContent.split(/\r?\n/).filter(line => line.trim() !== "");
    const parsed = lines.map(line => {
      const [chinese, pinyin, english] = line.split("|").map(s => s.trim());
      return { chinese: chinese || "", pinyin: pinyin || "", english: english || "" };
    });
    setChineseWords(parsed);
    setFileUploaded(true);
    setSelectedList("Custom Text Input");
    setShowChineseTextBoxInput(false);
    setChineseTextBoxContent("");
    setActiveView("");
  };

  async function fetchMeaning(word) {
    let meaningEn = "";
    let meaningZh = "";
    try {
      const res = await fetch(`https://api.dictionaryapi.dev/api/v2/entries/en/${word}`);
      const data = await res.json();
      meaningEn = data[0]?.meanings[0]?.definitions[0]?.definition || "";
      meaningEn = summarizeMeaning(meaningEn);
    } catch (e) {}
    try {
      const res = await fetch(
        `https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=zh-CN&dt=t&q=${encodeURIComponent(word)}`
      );
      const data = await res.json();
      meaningZh = data[0][0][0] || "";
    } catch (e) {}
    return { meaningEn, meaningZh };
  }

  function summarizeMeaning(text, maxLength = 120) {
    if (!text) return "";
    const sentences = text.match(/[^.!?]+[.!?]+/g);
    if (!sentences) return text.length <= maxLength ? text : text.substring(0, maxLength) + "...";
    let summary = "";
    for (const sentence of sentences) {
      if ((summary + sentence).length <= maxLength) {
        summary += sentence.trim() + " ";
      } else break;
    }
    return summary.trim() || sentences[0].trim();
  }

  const speakWord = useCallback((index = flashIndex) => {
    if (!words[index]) return;
    const word = words[index].word;
    speakText(word, 'en', 1.0);
    setTimeout(() => {
      const letters = word.split("").join(" ");
      speakText(letters, 'en', 0.6);
    }, 800);
  }, [words, flashIndex]);

  useEffect(() => {
    if (activeView === "flashcards" && words.length > 0) {
      speakWord(flashIndex);
    }
  }, [activeView, flashIndex, words, speakWord]);

  const handleGoHome = () => {
    setKidName("");
    setFileUploaded(false);
    setActiveView("");
    setFlashIndex(0);
    setWords([]);
    setChineseWords([]);
    setPracticeType("");
    setSelectedList("");
    setShowTextBoxInput(false);
    setTextBoxContent("");
    setShowChineseTextBoxInput(false);
    setChineseTextBoxContent("");
  };

  const handleSidebarChangePracticeType = (type) => {
    if (type === practiceType) return;
    setPracticeType(type);
    setFileUploaded(false);
    setWords([]);
    setChineseWords([]);
    setSelectedList("");
    setActiveView("");
  };

  const handleNavigate = (view) => {
    setActiveView(view);
    if (view === "flashcards" || view === "chinese-flashcards") {
      setFlashIndex(0);
    }
  };

  const showBottomNav = fileUploaded && kidName.trim().length >= 2;
  const wordCount = practiceType === "chinese" ? chineseWords.length : words.length;

  const renderActivityHub = () => (
    <div className="activity-hub">
      <div className="hub-emoji">🎉</div>
      <h1 className="hub-greeting">Ready, {kidName}!</h1>
      <div className="mode-list-info">
        <div className="mode-list-name">
          {practiceType === "chinese"
            ? <BrushIcon className="icon-sm" />
            : <AbcIcon className="icon-sm" />}
          {selectedList.replace(".txt", "").replace(/_/g, " ")}
        </div>
        <div className="mode-list-count">
          {wordCount} {practiceType === "chinese" ? "characters" : "words"}
        </div>
      </div>
      <p className="mode-hint">Choose an activity from the menu below ↓</p>
    </div>
  );

  const renderView = () => {
    if (activeView === "spelling") {
      return (
        <SpellingPractice
          words={words}
          kidName={kidName}
          onLogout={handleGoHome}
          onExit={() => setActiveView("")}
        />
      );
    }
    if (activeView === "flashcards") {
      return (
        <FlashCardView
          words={words}
          flashIndex={flashIndex}
          setFlashIndex={setFlashIndex}
          setFlashMode={v => { if (!v) setActiveView(""); }}
          speakWord={speakWord}
        />
      );
    }
    if (activeView === "wordlist") {
      return (
        <WordListView
          words={practiceType === "chinese" ? chineseWords : words}
          onBack={() => setActiveView("")}
        />
      );
    }
    if (activeView === "games") {
      return (
        <GamesHub
          words={practiceType === "chinese" ? chineseWords : words}
          practiceType={practiceType}
          kidName={kidName}
        />
      );
    }
    if (activeView === "chinese-flashcards") {
      return (
        <ChineseFlashCardView
          words={chineseWords}
          onExit={() => setActiveView("")}
        />
      );
    }
    if (activeView === "chinese-pinyin") {
      return (
        <ChineseSpellingView
          words={chineseWords}
          kidName={kidName}
          onExit={() => setActiveView("")}
        />
      );
    }
    if (activeView === "chinese-char-spelling") {
      return (
        <ChineseWritingView
          words={chineseWords}
          onExit={() => setActiveView("")}
          mode="spelling"
        />
      );
    }
    if (activeView === "chinese-writing") {
      return (
        <ChineseWritingView
          words={chineseWords}
          onExit={() => setActiveView("")}
          mode="practice"
        />
      );
    }
    return renderActivityHub();
  };

  return (
    <>
      <Header userName={kidName} onMenuOpen={() => setSidebarOpen(true)} />

      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        userName={kidName}
        practiceType={practiceType}
        selectedList={selectedList}
        fileUploaded={fileUploaded}
        activeView={activeView}
        onChangeName={name => setKidName(name)}
        onChangePracticeType={handleSidebarChangePracticeType}
        onLoadEnglishList={handleEnglishListChange}
        onLoadChineseList={loadChineseList}
        onFileUpload={handleFileUpload}
        onChineseFileUpload={handleChineseFileUpload}
        onTextInput={() => setShowTextBoxInput(true)}
        onChineseTextInput={() => setShowChineseTextBoxInput(true)}
        onNavigate={handleNavigate}
        onHome={handleGoHome}
      />

      <div className={`trainer-container${showBottomNav ? " has-bottom-nav" : ""}`}>

        {/* ── Setup screen (no list loaded) ── */}
        {!fileUploaded ? (
          <div className="trainer-card">
            <div className="setup-screen">
              <div className="setup-icon">
                <AutoStoriesIcon className="icon-main" />
              </div>
              <h1 className="welcome-title">Learning Adventure</h1>
              <p className="welcome-subtitle">Let's make learning fun!</p>

              {/* Name input */}
              <div className="setup-name-section">
                <input
                  type="text"
                  className="name-input"
                  placeholder="What's your name?"
                  value={kidName}
                  onChange={e => setKidName(e.target.value)}
                  autoFocus
                />
                {kidName.trim().length >= 2 && (
                  <div className="name-greeting">
                    <CheckCircleIcon className="icon-sm" />
                    Hi {kidName}! Pick a subject to start.
                  </div>
                )}
              </div>

              {/* Language cards — shown once name is valid */}
              {kidName.trim().length >= 2 && (
                <div className="lang-toggle-section">
                  <div className="list-label">
                    <AssignmentIcon className="icon-sm" />
                    What would you like to practice?
                  </div>
                  <div className="lang-cards">
                    <button
                      className={`lang-card${practiceType === "english" ? " active" : ""}`}
                      onClick={() => setPracticeType("english")}
                    >
                      <AbcIcon className="lang-card-icon" />
                      <span className="lang-card-name">English</span>
                      <span className="lang-card-sub">Spelling</span>
                    </button>
                    <button
                      className={`lang-card${practiceType === "chinese" ? " active" : ""}`}
                      onClick={() => setPracticeType("chinese")}
                    >
                      <BrushIcon className="lang-card-icon" />
                      <span className="lang-card-name">中文</span>
                      <span className="lang-card-sub">Chinese</span>
                    </button>
                  </div>
                </div>
              )}

              {/* English list selection */}
              {practiceType === "english" && (
                <div className="list-section">
                  <div className="list-label">
                    <AssignmentIcon className="icon-sm" />
                    Choose your spelling list:
                  </div>
                  <select
                    className="list-select"
                    defaultValue=""
                    onChange={async e => {
                      const fn = e.target.value;
                      if (fn) await handleEnglishListChange(fn);
                    }}
                  >
                    <option value="" disabled>Select a list...</option>
                    {ENGLISH_LISTS.map(l => (
                      <option key={l.value} value={l.value}>{l.label}</option>
                    ))}
                  </select>
                  <div className="list-divider"><span>or</span></div>
                  <div className="list-buttons">
                    <button className="btn btn-primary" onClick={() => setShowTextBoxInput(true)}>
                      <EditIcon className="icon-sm" /> Type Words
                    </button>
                    <label className="btn btn-outline">
                      <AttachFileIcon className="icon-sm" /> Upload File
                      <input type="file" accept=".txt" onChange={handleFileUpload} style={{ display: "none" }} />
                    </label>
                  </div>
                </div>
              )}

              {/* Chinese list selection */}
              {practiceType === "chinese" && (
                <div className="list-section">
                  <div className="list-label">
                    <TranslateIcon className="icon-sm" />
                    Choose your character list:
                  </div>
                  <select
                    className="list-select"
                    defaultValue=""
                    onChange={e => { const f = e.target.value; if (f) loadChineseList(f); }}
                  >
                    <option value="" disabled>Select a list...</option>
                    {CHINESE_LISTS.map(l => (
                      <option key={l.value} value={l.value}>{l.label}</option>
                    ))}
                  </select>
                  <div className="list-divider"><span>or</span></div>
                  <div className="list-buttons">
                    <button className="btn btn-primary" onClick={() => setShowChineseTextBoxInput(true)}>
                      <EditIcon className="icon-sm" /> Type Words
                    </button>
                    <label className="btn btn-outline">
                      <AttachFileIcon className="icon-sm" /> Upload File
                      <input type="file" accept=".txt" onChange={handleChineseFileUpload} style={{ display: "none" }} />
                    </label>
                  </div>
                </div>
              )}

              {loading && (
                <div className="loading-indicator">
                  <HourglassEmptyIcon className="loading-spin" />
                  Loading your list...
                </div>
              )}
            </div>
          </div>
        ) : (
          /* ── Activity area (list loaded) ── */
          <div className="trainer-card">
            {renderView()}
          </div>
        )}
      </div>

      {/* Bottom nav — only when list is loaded */}
      {showBottomNav && (
        <BottomNav
          activeView={activeView}
          practiceType={practiceType}
          onNavigate={handleNavigate}
        />
      )}

      {/* English text input modal */}
      {showTextBoxInput && (
        <div className="modal-backdrop">
          <div className="modal-content">
            <h2 className="modal-title">
              <EditIcon className="icon-md" /> Enter Your Spelling List
            </h2>
            <div className="modal-instructions">
              <p><CreateIcon className="icon-sm" /> Enter one word per line</p>
              <p><TipsAndUpdatesIcon className="icon-sm" /> Format: <code>word | english meaning | chinese meaning</code></p>
            </div>
            <textarea
              className="modal-textarea"
              value={textBoxContent}
              onChange={e => setTextBoxContent(e.target.value)}
              placeholder={"Example:\nadventure\nor\nadventure | an exciting experience | 冒险"}
              autoFocus
            />
            <div className="modal-actions">
              <button className="btn btn-ghost" onClick={() => { setShowTextBoxInput(false); setTextBoxContent(""); }}>
                Cancel
              </button>
              <button className="btn btn-success" onClick={handleTextBoxSubmit} disabled={!textBoxContent.trim()}>
                <CheckIcon className="icon-sm" /> Load Words
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Chinese text input modal */}
      {showChineseTextBoxInput && (
        <div className="modal-backdrop">
          <div className="modal-content">
            <h2 className="modal-title">
              <EditIcon className="icon-md" /> Enter Your Chinese List
            </h2>
            <div className="modal-instructions">
              <p><CreateIcon className="icon-sm" /> Enter one word per line</p>
              <p><TipsAndUpdatesIcon className="icon-sm" /> Format: <code>chinese | pinyin | english</code></p>
            </div>
            <textarea
              className="modal-textarea"
              value={chineseTextBoxContent}
              onChange={e => setChineseTextBoxContent(e.target.value)}
              placeholder={"Example:\n你好 | nǐ hǎo | hello\n谢谢 | xiè xiè | thank you"}
              autoFocus
            />
            <div className="modal-actions">
              <button className="btn btn-ghost" onClick={() => { setShowChineseTextBoxInput(false); setChineseTextBoxContent(""); }}>
                Cancel
              </button>
              <button className="btn btn-success" onClick={handleChineseTextBoxSubmit} disabled={!chineseTextBoxContent.trim()}>
                <CheckIcon className="icon-sm" /> Load Words
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
